export const userManuals = [
  {
    section: 'Credentialing/Profiling',
    subsections: [
      {
        url: 'https://nemtplatform.notion.site/Level-of-Service-Space-Type-Required-152910db0c1c80fa94fad7edf9079568',
        name: 'Level of Service/Space Type (Required) ',
        image: 'assets/images/manual/levelofservice.png'
      },
      {
        url: 'https://nemtplatform.notion.site/Funding-Source-Broker-Required-152910db0c1c803d82b6e30bcba498e8',
        name: 'Funding Source/Broker (Required) ',
        image: 'assets/images/manual/funding-source.png'
      },
      {
        url: 'https://nemtplatform.notion.site/Service-Areas-Required-for-Planner-152910db0c1c80869e3ec7485f1610a3',
        name: 'Service Areas (Required for Planner)',
        image: 'assets/images/manual/servicearea.png'
      },
      {
        url: 'https://nemtplatform.notion.site/Equipments-152910db0c1c8024929dd5a8724c8255',
        name: 'Equipments',
        image: 'assets/images/manual/equioments.png'
      },
      {
        url: 'https://nemtplatform.notion.site/Station-Manager-152910db0c1c802ab78ecf64dddead5a',
        name: 'Station Manager',
        image: 'assets/images/manual/station-manager.png'
      },
      {
        url: 'https://nemtplatform.notion.site/Vehicles-Fleet-Required-152910db0c1c803db5cdebec89b36dca',
        name: 'Vehicles/Fleet (Required)',
        image: 'assets/images/manual/vehicles.png'
      },
      {
        url: 'https://nemtplatform.notion.site/Drivers-Required-152910db0c1c80e58f1dfd8ae4d2e6e8',
        name: 'Drivers (Required)',
        image: 'assets/images/manual/add-driver.png'
      },
      {
        url: 'https://nemtplatform.notion.site/Rates-Required-152910db0c1c808ab17ec66aa9e561b1',
        name: 'Rates (Required)',
        image: 'assets/images/manual/rates.png'
      },
      {
        url: 'https://nemtplatform.notion.site/Addons-152910db0c1c80489ac8f70b5fa02cf9',
        name: 'Addons',
        image: 'assets/images/manual/addons.png'
      },
      {
        url: 'https://nemtplatform.notion.site/Primary-Diagnosis-Required-for-CMS1500-152910db0c1c807d9cedf6d1ac63b303',
        name: 'Primary Diagnosis (Required for CMS1500)',
        image: 'assets/images/manual/medical-dia.png'
      },
      {
        url: 'https://nemtplatform.notion.site/Modifiers-Required-for-CMS1500-152910db0c1c806a908cf4f66aded028',
        name: 'Modifiers (Required for CMS1500)',
        image: 'assets/images/manual/modifier.png'
      }
    ]
  },
  {
    section: 'Operations',
    subsections: [
      {
        url: 'https://nemtplatform.notion.site/Add-Member-1a8910db0c1c8051b353ec3f8b1825b3',
        name: 'Add Member',
        image: 'assets/images/manual/add-member.png'
      },
      {
        url: 'https://nemtplatform.notion.site/Create-Trip-152910db0c1c8098a26dccc738338148',
        name: 'Create Trip',
        image: 'assets/images/manual/create-trip.png'
      },
      {
        url: 'https://nemtplatform.notion.site/Import-Trips-via-API-152910db0c1c80d2b13dce82e22abd6c',
        name: 'Import Trips (via API)',
        image: 'assets/images/manual/import-via-api.png'
      },
      {
        url: 'https://nemtplatform.notion.site/Standing-Order-Recurring-Trips-152910db0c1c803abe90ece4b8820925',
        name: 'Standing Order/ Recurring Trips',
        image: 'assets/images/manual/recurring.png'
      },
      {
        url: 'https://nemtplatform.notion.site/How-to-assign-a-vehicle-169910db0c1c8032882ae1c60658a879',
        name: 'How to assign a vehicle?',
        image: 'assets/images/manual/assign-car.png'
      },
      {
        url: 'https://nemtplatform.notion.site/How-to-assign-a-trip-Regular-152910db0c1c80e5b17bcfe9c81e67d7',
        name: 'How to assign a trip? (Regular)',
        image: 'assets/images/manual/assign-trip.png'
      },
      {
        url: 'https://nemtplatform.notion.site/How-to-un-assign-a-trip-152910db0c1c804fa4e5c49ca8edc4a8',
        name: 'How to un-assign a trip?',
        image: 'assets/images/manual/un-assign-trip.png'
      },
      {
        url: 'https://nemtplatform.notion.site/How-to-cancel-a-trip-152910db0c1c802e89bec4a3aa42dd07',
        name: 'How to cancel a trip?',
        image: 'assets/images/manual/cancel-trip.png'
      },
      {
        url: 'https://nemtplatform.notion.site/How-to-archive-a-trip-152910db0c1c80d3a02eec1cd51fb009',
        name: 'How to archive a trip?',
        image: 'assets/images/manual/archives.png'
      },
      {
        url: 'https://nemtplatform.notion.site/Unassigned-Trips-List-152910db0c1c8040bed7c30067c4c7e7',
        name: 'Unassigned Trips (List)',
        image: 'assets/images/manual/unassignedlist.png'
      },
      {
        url: 'https://nemtplatform.notion.site/Assigned-Trips-List-152910db0c1c8020bf45f53a3d072883',
        name: 'Assigned Trips (List)',
        image: 'assets/images/manual/assign-trip-list.png'
      },
      {
        url: 'https://nemtplatform.notion.site/Canceled-Trips-List-152910db0c1c80bdab5ef7615329ea09',
        name: 'Canceled Trips (List)',
        image: 'assets/images/manual/cancel-list.png'
      },
      {
        url: 'https://nemtplatform.notion.site/Completed-Trips-List-152910db0c1c80ac935ad531b6d4e24f',
        name: 'Completed Trips (List)',
        image: 'assets/images/manual/completed-trip.png'
      },
      {
        url: 'https://nemtplatform.notion.site/Driver-Load-152910db0c1c80d7904aeba45171e590',
        name: 'Driver Load',
        image: 'assets/images/manual/driver-loads.png'
      }
    ]
  }
];
